import { create } from "zustand";

type State = { open: boolean; toggle: () => void; close: () => void; openIt: () => void; };
export const useSidebar = create<State>((set) => ({
  open: false,
  toggle: () => set((s) => ({ open: !s.open })),
  close: () => set({ open: false }),
  openIt: () => set({ open: true }),
}));
